import { Routes, Route } from "react-router-dom";

import Home from "./Pages/Home/index";

import ProcurementManagement from "./Pages/Solution/ProcurementManagement";

import Product from "./Pages/Product/Product";
import Team from "./Pages/Company/Team/Teams";
import Features from "./Pages/Product/Features/Features";
import Pricing from "./Pages/Pricing/Pricing";
import GetInToTouch from "./Pages/Contact/Getintouch/GetInToTouch";
import FeedBack from "./Pages/Contact/FeedBack/FeedBack";
import AskUs from "./Pages/Contact/AskUs/AskUs";
import AboutUs from "./Pages/Company/AboutUs/Aboutus";
import Culture from "./Pages/Company/Culture/Culture";
import Success from "./Pages/Company/Success/Success";
import Industries from "./Pages/Industries/Industries";
import LeadershipTeam from "./Pages/Company/Leadership/LeadershipTeam";

const RouterNav = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route
          path="ProcurementManagement"
          element={<ProcurementManagement />}
        />
        <Route path="team" element={<Team />} />
        <Route path="Leadership" element={<LeadershipTeam />} />

        <Route path="product" element={<Product />} />
        <Route path="features" element={<Features />} />

        <Route path="pricing" element={<Pricing />} />
        <Route path="getintotouch" element={<GetInToTouch />} />
        <Route path="feedback" element={<FeedBack />} />
        <Route path="askus" element={<AskUs />} />
        <Route path="about" element={<AboutUs />} />
        <Route path="our-culture" element={<Culture />} />
        <Route path="our-success" element={<Success />} />
        <Route path="industries" element={<Industries />} />

      </Routes>
    </>
  );
};
export default RouterNav;
